module.exports = __webpack_public_path__ + "static/media/icon_service_instore.9dca3a94.svg";